import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { Gracias } from './pages/Gracias';
import { Seguimiento } from './pages/Seguimiento';
import { WhatsAppGateProvider } from './contexts/WhatsAppGateContext';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3fa89pae26y7h">
      <WhatsAppGateProvider data-id="element-1" data-mp="3fbt2augtc72p">
        <Routes data-id="element-2" data-mp="3f8exlfkofls3">
          <Route path="/" element={<Landing data-id="element-4" data-mp="2rk45b0t1quff" />} data-id="element-3" data-mp="2rkx5fixi2lol" />
          <Route path="/gracias" element={<Gracias data-id="element-6" data-mp="2risy0r0e74jk" />} data-id="element-5" data-mp="2rlp10tr3kjev" />
          <Route path="/seguimiento" element={<Seguimiento data-id="element-8" data-mp="2mn5bykh7iria" />} data-id="element-7" data-mp="2mm2nskb9r362" />
          <Route path="*" element={<Landing data-id="element-10" data-mp="31aqf2ee30qq7" />} data-id="element-9" data-mp="2mjpvbd7vxaer" />
        </Routes>
      </WhatsAppGateProvider>
    </BrowserRouter>;
}